<header class="go-page-title">
  <h1 class="go-heading-1">{{ pageTitle }}</h1>
</header>
<section class="go-container">
  <go-card [showHeader]="false" class="go-column go-column--33">
    <div go-card-content>
      <p class="go-body-copy">
        The goDesign standards detail all that goes into creating and maintaining our design system.
        This is the foundation we build all of our components on top of. Every component is designed
        with these standards in mind and all elements, when implemented, are expected to comply with
        these guidelines.
      </p>
      <p class="go-body-copy">
        This methodology is heavily based on <a class="go-link" href="http://atomicdesign.bradfrost.com">Atomic Design</a>
        which lends itself towards thinking of our UIs as thoughtful hierarchies, discusses the qualities of
        effective pattern libraries, and showcases techniques to transform your team's design and development workflow.
      </p>
    </div>
  </go-card>
</section>
